import React from "react";
import { useSelector } from "react-redux";
import { Table } from "reactstrap";

const TableComponent = ({ children }) => {
  const { user } = useSelector((state) => state.auth);
  const scrollbarThumbColor = user?.adminColor || "#cf327b";

  return (
    <Table
      className="align-items-center table-flush"
      responsive
      style={{
        overflowX: "auto",
        scrollbarColor: `${scrollbarThumbColor} transparent`,
        scrollbarWidth: "thin",
      }}
    >
      {children}
      <style>
        {`
          ::-webkit-scrollbar {
            height: 4px;
            width: 4px;
            background: rgb(246, 243, 243);
          }

          ::-webkit-scrollbar-thumb:horizontal {
            background: ${scrollbarThumbColor};
            border-radius: 10px;
          }
        `}
      </style>
    </Table>
  );
};

export default TableComponent;
